// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ldLF","textarea":"styles_textarea__obdZp"};